import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import Sidebar from "../../Component/Sidebar";
import TopBar from "../../Component/TopBar";
import { Checkbox, DatePicker, message } from "antd";
import { navigateTo } from "../../utils/navigation";
import {
  Avatar,
  Card,
  Flex,
  Switch,
  Steps,
  Popover,
  Upload,
  Button,
} from "antd";
import { getAppoinments } from "../../redux/api/Appoinment";
import { useDispatch } from "react-redux";
import "./index.css";
import moment from "moment/moment";
import { LuClock3 } from "react-icons/lu";
import { CiVideoOn } from "react-icons/ci";
import { IoCall } from "react-icons/io5";
import { IoChatbubblesOutline } from "react-icons/io5";
import { BsPerson } from "react-icons/bs";
import progress from "../../assets/images/progress.png";
import prescription_url from "../../assets/images/prescription_url.png";
import completed from "../../assets/images/completed.png";
import error_step from "../../assets/images/error_step.png";
import { UploadOutlined } from "@ant-design/icons";
import update_pres from "../../assets/images/update_pres.png";
import { uploadFile } from "../../redux/api/Upload/Image";
import { endCallApi } from "../../redux/api/Call/EndCallSlice";
import no_data from "../../assets/images/no_data.png";
import { getOrganisationData } from "../../redux/api/Organisation";
import not_completed from "../../assets/images/not_completed.png";
import { LuNotepadText } from "react-icons/lu";
import for_student from "../../assets/images/for_student.png";
import for_pract from "../../assets/images/for_pract.png";
export default function Index() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedApp, setSelectedApp] = useState(null);
  const [url, setUrl] = useState(null);
  const items = [
    {
      title: "Finished",
    },
    {
      title: "In Progress",
    },
    {
      title: "Waiting",
    },
  ];

  const onChange = (date, dateString) => {
    console.log(date, dateString);
  };

  const getData = () => {
    setLoading(true);
    let userData = JSON.stringify({
      pastAppointment: true,
    });
    dispatch(getAppoinments(userData)).then((res) => {
      setLoading(false);

      let data = res.payload.data.payload;
      let completed = setData(data);
    });
  };

  const formatDate = (dateString) => {
    const givenDate = moment(dateString, "YYYY-MM-DD"); // Parse the given date
    const today = moment(); // Get today's date

    if (givenDate.isSame(today, "day")) {
      return "On " + givenDate.format("D MMMM, dddd YYYY");
    } else {
      return "On " + givenDate.format("D MMMM, dddd YYYY"); // Format as "18 October, Friday 2024"
    }
  };

  const doNavigation = (item) => {
    navigateTo("/call/" + item.mode + "/" + item.channel);
  };

  const customDot = (dot, { status, index }) => (
    <Popover
      content={
        <span>
          step {index} status: {status}
        </span>
      }
    >
      {dot}
    </Popover>
  );

  const onChangeImage = (info) => {
    let formData = new FormData();
    formData.append("file", info.file.originFileObj);
    formData.append("category", "SESSION_PRESCRIPTION");
    dispatch(uploadFile(formData)).then((res) => {
      if (res.payload.status === "success") {
        let userData = {
          //prescriptionRequired: !prescriptionNotRequired,

          id: selectedApp,
          status: "COMPLETED",
          pdfUrl: res.payload.message.payload,
        };
        dispatch(endCallApi(userData)).then((res) => {
          getData();
        });
      } else {
        message.error("Something went wrong while uploading prescription");
      }
    });
  };

  const getOrganisation = () => {
    dispatch(getOrganisationData()).then((res) => {
      if (res.payload.status === "success") {
        let profileUpdate = res.payload.message.payload.profileUpdate;
        let availiblityUpdate =
          res.payload.message.payload.proavailiblityUpdatefileUpdate;
        if (profileUpdate === true) {
          navigateTo("/profile");
        }
        if (availiblityUpdate === true) {
          navigateTo("/set-availability");
        }
      }
    });
  };

  const getStatus = (item) => {
    if (item.studentJoined === false) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Image
              src={for_student}
              style={{
                width: "120px",
                height: "34px",
              }}
            />
          </div>
        </div>
      );
    } else if (item.counsellorJoined === false) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Image
              src={for_pract}
              style={{
                width: "120px",
                height: "34px",
              }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Upload
              showUploadList={false}
              onChange={onChangeImage}
              onClick={() => setSelectedApp(item.appointmentId)}
            >
              <Image
                src={update_pres}
                style={{
                  width: "120px",
                  height: "34px",
                }}
              />
            </Upload>
            <Checkbox
              onChange={() => {
                dispatch(
                  endCallApi({
                    id: item.appointmentId,
                    status: "COMPLETED",
                    prescriptionRequired: false,
                  })
                ).then((res) => {
                  getData();
                });
              }}
            >
              <span
                style={{
                  color: "#8E8E8E",
                  fontSize: "8px",
                }}
              >
                {"Prescription not required"}
              </span>
            </Checkbox>
          </div>
        </div>
      );
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getOrganisation();
  }, []);

  return (
    <Container
      fluid
      className="parent-container"
      style={{ background: "#EDF5FF" }}
    >
      <Row>
        <Col md={2}>
          <Sidebar />
        </Col>
        <Col md={10} style={{ marginTop: "90px" }}>
          <Container className="upcoming-appoinment-header">
            <h4 className="title">Past Appointments</h4>
            {/* <DatePicker
              onChange={onChange}
              placeholder={"Appointment Schedule"}
              style={{ width: "200px" }}
            /> */}
          </Container>
          <Container style={{ marginTop: "45px", overflow: "auto" }}>
            {Object.entries(data).length > 0 ? (
              <>
                {Object.entries(data)
                  .reverse() // Reversing the order of dates, you can adjust this if needed
                  .map(([date, appointments]) => {
                    return (
                      <>
                        <div className="date-heading">
                          <span>{formatDate(date)}</span>
                        </div>
                        <Row>
                          {[...appointments] // Create a shallow copy of the appointments array
                            .sort((a, b) => {
                              // Sort appointments within the same date by start time (most recent first)
                              const timeA = new Date(`1970-01-01T${a.startTime}`);
                              const timeB = new Date(`1970-01-01T${b.startTime}`);
                              return timeB.getTime() - timeA.getTime(); // Most recent time first
                            })
                            .map((item) => {
                              return (
                                <Col md={3} style={{ padding: "5px" }}>
                                  <div
                                    className="item-card"
                                    style={{
                                      padding: "10px",
                                      background: "#FFFFFF",
                                      marginTop: "10px",
                                    }}
                                  >
                                    <div>
                                      <div>
                                        {item.status === "COMPLETED" ? (
                                          <Image
                                            src={progress}
                                            style={{ width: "100%" }}
                                          />
                                        ) : item.status === "IN_COMPLETE" ||
                                          item.studentJoined === false ||
                                          item.counsellorJoined === false ? (
                                          <Image
                                            src={not_completed}
                                            style={{ width: "100%" }}
                                          />
                                        ) : (
                                          <Image
                                            src={error_step}
                                            style={{ width: "100%" }}
                                          />
                                        )}
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <div
                                          className="mode-box"
                                          style={{
                                            height: "30px",
                                            width: "120px",
                                          }}
                                        >
                                          <div style={{ marginRight: "5px" }}>
                                            {item.mode === "VIDEO" ? (
                                              <CiVideoOn color={"#45413C"} />
                                            ) : item.mode === "AUDIO" ? (
                                              <IoCall color={"#45413C"} />
                                            ) : item.mode === "CHAT" ? (
                                              <IoChatbubblesOutline
                                                color={"#45413C"}
                                              />
                                            ) : (
                                              <BsPerson color={"#45413C"} />
                                            )}
                                          </div>
                                          <span
                                            className="mode-value"
                                            style={{ fontSize: "12px" }}
                                          >
                                            {item.mode === "VIDEO"
                                              ? "Video"
                                              : item.mode === "AUDIO"
                                              ? "Audio"
                                              : item.mode === "CHAT"
                                              ? "Chat"
                                              : "In Person"}
                                          </span>
                                        </div>
                                        {item.status === "COMPLETED" ? (
                                          <div
                                            style={{
                                              height: "60px",
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Image
                                              src={completed}
                                              style={{
                                                width: "80px",
                                                height: "30px",
                                              }}
                                            />
                                          </div>
                                        ) : (
                                          <>{getStatus(item)}</>
                                        )}
                                      </div>
                                      <div
                                        className="item-footer"
                                        style={{
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                          }}
                                        >
                                          <Avatar
                                            src={item.imageURL}
                                            size={45}
                                          />
                                          <div style={{ marginLeft: "10px" }}>
                                            <span className="student-name">
                                              {item.firstName} {item.lastName}
                                            </span>
                                            <span className="appoinment-id">
                                              {item.appointmentId}
                                            </span>
                                          </div>
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          {item.url !== null ? (
                                            <Image
                                              src={prescription_url}
                                              style={{
                                                width: "50px",
                                                height: "30px",
                                              }}
                                              onClick={() => {
                                                window.open(item.url, "_blank");
                                              }}
                                            />
                                          ) : null}
                                          {item.notesUrl !== null ? (
                                            <LuNotepadText
                                              color={"#4B61FF"}
                                              size={18}
                                              onClick={() => {
                                                window.open(
                                                  item.notesUrl,
                                                  "_blank"
                                                );
                                              }}
                                            />
                                          ) : null}
                                        </div>
                                      </div>
                                      <div
                                        className="item-header"
                                        style={{
                                          marginTop: "10px",
                                        }}
                                      >
                                        <div style={{ marginRight: "5px" }}>
                                          <LuClock3 color={"#FFFFFF"} />{" "}
                                        </div>
                                        <span style={{ fontSize: "14px" }}>
                                          {moment(
                                            item.startTime,
                                            "HH:mm:ss"
                                          ).format("HH:mm a")}{" "}
                                          -{" "}
                                          {moment(
                                            item.endTime,
                                            "HH:mm:ss"
                                          ).format("HH:mm a")}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              );
                            })}
                        </Row>
                      </>
                    );
                  })}
              </>
            ) : (
              <Container
                style={{
                  height: "600px",
                  background: "#4B61FF",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "20px",
                  marginTop: "20px",
                }}
              >
                <div>
                  <center>
                    <Image
                      src={no_data}
                      style={{
                        display: "inline-block",
                      }}
                    />
                  </center>
                  <br />
                  <span
                    className="availability-box-bulk-heading"
                    style={{
                      color: "#FFFFFF",
                      marginLeft: "10px",
                    }}
                  >
                    No Data to Show
                  </span>
                </div>
              </Container>
            )}
          </Container>
        </Col>
      </Row>
    </Container>
  );
}
